module.exports = __webpack_public_path__ + "static/img/logo-inverted.ddbdb1a1.svg";